import {
  Card,
  CardHeader,
  SvgIcon,
  CardContent,
  CardActions,
} from '@mui/material';
import { Formik, FormikHelpers } from 'formik';
import {
  AppFormikPasswordField,
  AppPrimaryButton,
} from 'shared/components/AppComponents';
import { ReactComponent as Play } from 'assets/images/ic_lock.svg';
import { ChangePasswordScheme } from 'validators/ChangePasswordSchema';
import { ProfileService } from 'services/ProfileService';
import { Toast, Utils } from 'shared/helpers';
import { BaseApplicationState } from 'state/baseapplication/Reducer';
import { useSelector } from 'react-redux';

const ChangePasswordCard: React.FC = () => {
  // UI Actions
  const actionOnSubmit = (
    formValues: any,
    formikHelper: FormikHelpers<any>
  ): void => {
    ProfileService.changePassword({
      oldPassword: formValues.currentPassword,
      newPassword: formValues.newPassword,
    })
      .then(() => {
        formikHelper.resetForm();
        Toast.showInfoMessage('Password changed successfully');
      })
      .catch((error) => {
        Utils.handleErrorResponse(error);
      })
      .finally(() => {
        formikHelper.setSubmitting(false);
      });
  };

  const { orgACLConfig }: BaseApplicationState = useSelector(
    (state: any) => state.baseAppState
  );

  // UI Elements
  return (
    <Formik
      initialValues={{
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      }}
      enableReinitialize
      validateOnMount
      validationSchema={ChangePasswordScheme}
      onSubmit={(formValues, formikHelper) => {
        actionOnSubmit(formValues, formikHelper);
      }}
    >
      {({ handleSubmit, isSubmitting }) => (
        <Card variant="outlined" className="change-password-content">
          <CardHeader
            title="Change Password"
            avatar={
              <SvgIcon
                component={Play}
                inheritViewBox
                className="view-icon"
                fontSize="inherit"
                htmlColor="#76A81F"
              />
            }
          />
          <CardContent>
            <AppFormikPasswordField
              name="currentPassword"
              outerLabel
              label="Current Password"
              placeholder="Enter your current password"
            />
            <AppFormikPasswordField
              name="newPassword"
              outerLabel
              label="New Password"
              placeholder="Enter your new password"
            />
            <AppFormikPasswordField
              name="confirmPassword"
              outerLabel
              label="Confirm New Password"
              placeholder="Enter your new password"
            />
          </CardContent>
          <CardActions>
            {orgACLConfig.settings?.includes(
              'settings.security.changePassword'
            ) && (
              <AppPrimaryButton
                isLoading={isSubmitting}
                disabled={isSubmitting}
                title="Change Password"
                onClick={handleSubmit}
              />
            )}
          </CardActions>
        </Card>
      )}
    </Formik>
  );
};

export default ChangePasswordCard;
